export type ImageParamsMappingType = {
  [key: string]: string;
};

// Add query parameters such as WID and mimetype to the image's URL to reduce both file size and image dimensions.
export const ImagesParamsMap: ImageParamsMappingType = {
  front_facing: '?wid=400&mimetype=image/webp',
  back_facing: '?wid=400&mimetype=image/webp',
  '3_4_back_facing': '?wid=400&mimetype=image/webp',
  dashboard_interior: '?wid=400&mimetype=image/webp',
};
